module.exports = __webpack_public_path__ + "img/41.fd7bf2f9.jpg";